module.exports = __webpack_public_path__ + "img/Qatar_logo.319c71d3.png";